import React from 'react';
import { Route, Switch } from "react-router-dom";
import AdcuMakerReportsModule from './adcu-maker-reports-module/adcu-maker-reports-module';

const AdcuMakerReports = () => {
  return (
    <Switch>
      <Route exact path="/tax-exempt-reports">
        <AdcuMakerReportsModule />
      </Route>
    </Switch>
  )
}

export default AdcuMakerReports;